import React from 'react'
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Header, Modal, Grid, Checkbox, Divider } from 'semantic-ui-react'
import diamond from '../../../../../images/grafix-icon/diamond.svg'
import TextEditor from '../../../../common/TextEditor';
import { durationValidation } from '../../../../common/RegexValidation';

class AddActivityModal extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      MakeAnotherActivity: false,
      milestoneCheck: false,
      name: '',
      description: ''
    }
    this.onSubmitActivity = this.onSubmitActivity.bind(this);
    this.setMilestone = this.setMilestone.bind(this);
    this.setMakeAnotherActivity = this.setMakeAnotherActivity.bind(this);
    this.updateText = this.updateText.bind(this)
  }

  componentWillMount() {
  }

  handleClose = () => {
    dispatch.initiatives.addActivityModalOpen(false);
    this.setState({ 'milestoneCheck': false })
    this.setState({
      MakeAnotherActivity: false,
      'description': '',
      'name': ''
    });
  }

  onSubmitActivity(formData) {
    let nodeToAdd
    nodeToAdd = {
      name: this.state.name,
      description: this.state.description,
      initiativeId: this.props.selectedInitiative._id,
      lastUpdatedBy: this.props.user,
      parentActivity: this.props.parentId,
      isLeafNode: true,
      duration: formData.duration ? formData.duration : 1,
      isMilestone: this.state.milestoneCheck,
      accountId: this.props.selectedInitiative.accountId,
      organizationId: this.props.selectedInitiative.organizationId
    }
    dispatch.initiatives.createActivity(nodeToAdd);
    this.setState({ 'description': '' })
    if (!this.state.MakeAnotherActivity) {
      dispatch.initiatives.addActivityModalOpen(false);
    }
    else {
      this.form.reset();
    }
    this.setState({ 'milestoneCheck': false })
  }

  setMilestone(event, data) {
    this.setState({ 'milestoneCheck': data.checked })

  }
  setMakeAnotherActivity(event, data) {
    this.setState({ MakeAnotherActivity: data.checked });
  }

  updateText(data, name) {
    if (name === "Name") {
      this.setState({ name: data })
    } else if (name === "Description") {
      this.setState({ description: data })
    }
  }

  render() {
    const errorLabel = <div className="customErrorLabel margin_bottom_10" />;
    const inlineStyle = {
      modal: {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
      }
    };
    return (
      <Modal
        style={inlineStyle.modal}
        open={this.props.isAddActivityModalOpen}
        onClose={this.handleClose}
        size='tiny'
        className="basicModal"
        closeOnEscape={true}
        closeOnDimmerClick={false}
        closeIcon
      >
        <Header content={"Add new activity under " + this.props.parentName} ></Header>
        <Divider />
        <Form noValidate
          ref={ref => this.form = ref}
          id="AddActivityForm"
          preventExternalInvalidation={true}
          onValidSubmit={(event) => { this.onSubmitActivity(event) }}
        >
          <Modal.Content>
            <Grid>
              <Grid.Row className="">
                <Grid.Column width={16}>

                  <TextEditor
                    name="Name"
                    text={this.state.name}
                    type="text"
                    onChangeText={this.updateText}
                    autoFocus
                  />

                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>

                  <TextEditor
                    name="Description"
                    text={this.state.description}
                    type="textarea"
                    onChangeText={this.updateText}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row className="pad_0">
                <Grid.Column width={8}>
                  <div>
                    <Form.Input
                      name="duration"
                      label="Duration (In Days)"
                      id="duration"
                      validations={{ matchRegexp: durationValidation }}
                      validationErrors={{
                        matchRegexp: 'Enter valid duration upto 3 digit.',
                      }}
                      errorLabel={errorLabel}

                    />
                  </div>
                </Grid.Column>
                <Grid.Column width={8}>
                  <div style={{ textAlign: 'right' }}><br />
                    <img src={diamond} name="diamond" style={{ 'height': '12px' }} alt="milestone" />&nbsp;
                        <span>Milestone Activity</span>
                    <Checkbox className='diamond-location' checked={this.state.milestoneCheck} onChange={(event, data) => { this.setMilestone(event, data) }} />
                  </div>
                </Grid.Column>
              </Grid.Row>


            </Grid>
          </Modal.Content>
          <Divider />
          <Modal.Actions className="actionInFormcy">
            <div className="float-left" style={{ textAlign: 'left' }}>
              <span>Create Another Activity</span>
              <Checkbox className='diamond-location' checked={this.state.MakeAnotherActivity}
                onChange={(event, data) => this.setMakeAnotherActivity(event, data)} />
            </div>

            <Button
              className="button-submit float-right"
              formNoValidate={true}
              id='addbtn'
              type="submit"> Add
             </Button>
            <Button
              id='cancelBtn'
              className="button-cancel"
              onClick={this.handleClose}
              type="button"> Cancel
             </Button>
          </Modal.Actions>
        </Form>
      </Modal>
    )
  }
}

export default AddActivityModal